import React, { useContext } from 'react';
import { Route, Switch } from 'react-router';

import { Loader } from 'components/commons';

import AppLoader from 'components/commons/app-loader/app-loader';
import { AppContext, UserContext } from 'contexts';
import { Path } from 'enums';

import { useMount } from 'hooks';

import { Fragment } from 'react';
import Header from 'components/commons/header/header';
import Sidebar from 'components/commons/sidebar/sidebar';
import IndexPage from './index.page';
import TransactionPage from './transaction.page';
import UsersPage from './users.page';
import CustomerPage from './customer.page';
import ProductPage from './product.page';

const AuthorizedPage = () => {
  const { appState } = useContext(AppContext);

  useMount(async () => {});

  const loading = false;

  if (loading) {
    return <AppLoader />;
  }

  return (
    <div>
      <UserContext.Provider value={{ role: localStorage.getItem('role'), userId: Number(localStorage.getItem('userId')) }}>
        <Loader open={appState?.loading} />
        <Fragment>
          <Header />
          <Sidebar />
          <div
            style={{
              marginLeft: '196px',
              marginTop: '60px',
              padding: '27px 36px',
              minWidth: '1170px',
              overflowX: 'auto',
              minHeight: '100vh'
            }}
          >
            <Switch>
              {[
                // [Path.Slash, DashboardPage, true, 'DASHBOARD'],
                [Path.Index, IndexPage, true, 'INDEX'],
                [Path.Transaction, TransactionPage, false, 'TRANSACTION'],
                [Path.Users, UsersPage, true, 'USERS'],
                [Path.Products, ProductPage, true, 'PRODUCTS'],
                [Path.Customer, CustomerPage, false, 'CUSTOMER']
              ].map(([path, component, exact], key) => (
                <Route key={key} path={path} component={component} exact={exact} />
              ))}
            </Switch>
          </div>
        </Fragment>
      </UserContext.Provider>
    </div>
  );
};

export default AuthorizedPage;
